export class GenericError<T> extends Error {
  statusCode: number;
  status: string;
  data: T;

  constructor(message: string, statusCode: number, status: string, data: T) {
    super(message);
    this.statusCode = statusCode;
    this.status = status;
    this.data = data;
    Object.setPrototypeOf(this, GenericError.prototype);
  }

  toString() {
    return this.statusCode + ': ' + this.status;
  }
}
